
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill": "#FFF",
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M8 1C4.134 1 1 4.134 1 8s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 12.813c-3.21 0-5.813-2.604-5.813-5.813 0-3.21 2.604-5.813 5.813-5.813 3.21 0 5.813 2.604 5.813 5.813 0 3.21-2.604 5.813-5.813 5.813z",
                        "transform": "translate(-779 -135) translate(642 125) translate(137 10)"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M7.25 5.25c0 .414.336.75.75.75s.75-.336.75-.75S8.414 4.5 8 4.5s-.75.336-.75.75zM8.375 7h-.75c-.069 0-.125.056-.125.125v4.25c0 .069.056.125.125.125h.75c.069 0 .125-.056.125-.125v-4.25C8.5 7.056 8.444 7 8.375 7z",
                        "transform": "translate(-779 -135) translate(642 125) translate(137 10)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  